/**
 * Resolves the variation the analytics surfaces compare against: the one
 * flagged `isControl`, falling back to the first variation.
 *
 * Eight call sites wrote this by hand as
 * `find((v) => v.isControl)?.id || variations[0].id || ""` and the copies
 * drifted. `RolloutsAnalyticsTable` plus the Conversion/Discount/Order
 * dashboards indexed `variations[0]` with no guard, so an experience whose
 * variation list is empty threw `Cannot read properties of undefined
 * (reading 'id')` — Sentry WEB-UI-9BF — out of the price-rollout dialog.
 * `PriceUpdaterDialog`, which passes that very list into the table, already
 * guarded its own copy with `?.`.
 *
 * Resolving it once keeps the empty-list fallback the guarded copies always
 * had, and leaves one place for the next reader to change.
 */
export const getControlVariationId = (
  variations: readonly { id: string; isControl?: boolean }[] | undefined
): string =>
  variations?.find((variation) => variation.isControl)?.id ||
  variations?.[0]?.id ||
  "";
